export default __webpack_public_path__ + "static/healthy-20602099778a676a512d5abe83bf9d73.png";